export interface DataExportStatus {
    progress?: number;
    secondaryProgress?: string;
    errorMessage?: string;
    complete: boolean;
    downloadUrl?: string;
}

const PollIntervalMs = 500;
const MaxConsecutiveFailures = 240;

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export const formatDataExportProgress = (status: DataExportStatus) =>
    status.progress + '%' + (status.secondaryProgress ? ' - ' + status.secondaryProgress : '');

/**
 * Polls an export until it completes. Exports run for hours in a separate worker, so a single
 * failed poll (a token being renewed, an API instance recycling) must not abandon one that is
 * still running; only a sustained run of failures gives up.
 */
export const pollDataExportStatus = async (
    getStatus: () => Promise<DataExportStatus>,
    onProgress: (progressText: string) => void
): Promise<DataExportStatus> => {
    let consecutiveFailures = 0;

    while (true) {
        try {
            const status = await getStatus();
            consecutiveFailures = 0;
            onProgress(formatDataExportProgress(status));

            if (status.complete) {
                return status;
            }
        } catch (e) {
            consecutiveFailures++;

            if (consecutiveFailures >= MaxConsecutiveFailures) {
                throw e;
            }
        }

        await delay(PollIntervalMs);
    }
};
